<template>
  <div
    :class="$style.container"
    data-sb-regression="sb-filter-chips"
  >
    <sb-chip
      v-for="chip of chips"
      :key="chip.key + '-' + chip.text"
      data-sb-automation="filter-selection-chip"
      dismissable
      version="next"
      @close="() => handlerRemoveFilter(chip.key)"
    >
      {{ chip.text }}
    </sb-chip>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import SbChip from '@src/components/Chip/SbChip.vue';
import { getValidFilters } from '@src/components/Filter/next/utils';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['removed-filter']);
const { t } = useI18n();

const props = defineProps({
  filters: {
    type: Array,
    default: () => [],
  },
  appliedFilters: {
    type: Object,
    default: () => ({}),
  },
});

const filters = computed(() => {
  return [...props.filters, { key: 'Search', name: 'Search' }];
});

const chips = computed(() => {
  if (!props.appliedFilters) {
    return [];
  }
  return getValidFilters(filters.value, props.appliedFilters, t);
});
function handlerRemoveFilter(key) {
  emit('removed-filter', key);
}
</script>

<style lang='scss' module>
.container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--p-spacing-xs);
  font-weight: var(--p-weights-semi-bold);
}
</style>
